var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOpenBible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 70,
    viewBox: "0 0 88 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3998 23.7082C58.9952 23.8114 59.5635 23.4166 59.6717 22.8198C60.4385 18.5572 61.1917 14.344 61.9495 10.1128C62.0577 9.51601 61.6563 8.94617 61.0564 8.84297H61.0339C60.434 8.73079 59.8612 9.13013 59.7529 9.7269C58.9907 13.9895 58.2374 18.1983 57.4752 22.4339C57.3669 23.0307 57.7729 23.605 58.3727 23.7082H58.3998Z",
    fill: "url(#paint0_linear_616_12728)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5994 27.1237L66.622 27.1372C67.1362 27.4647 67.8172 27.3167 68.1465 26.8051C70.1265 23.7406 72.093 20.6939 74.0686 17.6338C74.3978 17.1223 74.249 16.4403 73.7348 16.1172L73.7123 16.1038C73.1981 15.7807 72.5215 15.9288 72.1923 16.4358C70.2167 19.4959 68.2502 22.5381 66.2702 25.6026C65.9409 26.1097 66.0898 26.7917 66.5994 27.1192V27.1237Z",
    fill: "url(#paint1_linear_616_12728)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5142 32.4579L73.5277 32.4804C73.8118 33.0188 74.4839 33.2252 75.0206 32.938C77.2668 31.7535 79.4949 30.5824 81.7365 29.4023C82.2733 29.1197 82.4807 28.4556 82.1966 27.9216L82.1831 27.8947C81.8989 27.3608 81.2269 27.1544 80.6901 27.4415C78.4395 28.6306 76.2159 29.8017 73.9787 30.9817C73.442 31.2644 73.2345 31.924 73.5187 32.4579H73.5142Z",
    fill: "url(#paint2_linear_616_12728)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2449 22.8196C29.3531 23.4118 29.9169 23.8112 30.5168 23.708H30.5394C31.1437 23.6003 31.5452 23.0305 31.4369 22.4292C30.6792 18.1935 29.926 13.9848 29.1592 9.72216C29.0509 9.1254 28.4781 8.72606 27.8782 8.83375H27.8557C27.2558 8.94592 26.8589 9.51577 26.9626 10.108C27.7204 14.3347 28.4736 18.548 29.2404 22.8151L29.2449 22.8196Z",
    fill: "url(#paint3_linear_616_12728)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7651 26.8089C21.0944 27.3205 21.7799 27.4685 22.2896 27.141L22.3121 27.1275C22.8218 26.8 22.9707 26.1224 22.6414 25.6109C20.6614 22.5419 18.6948 19.5042 16.7193 16.4441C16.3901 15.9371 15.709 15.7845 15.1993 16.1121L15.1768 16.1255C14.6626 16.4531 14.5137 17.1306 14.843 17.6421C16.8185 20.7022 18.7851 23.7444 20.7651 26.8134V26.8089Z",
    fill: "url(#paint4_linear_616_12728)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17998 29.4035C9.42163 30.5836 11.6452 31.7591 13.8959 32.9392C14.4371 33.2219 15.1092 33.0155 15.3888 32.4815L15.4024 32.4591C15.682 31.9252 15.4745 31.2656 14.9423 30.9829C12.7052 29.8028 10.4816 28.6273 8.2309 27.4427C7.69417 27.16 7.02212 27.3619 6.73797 27.8959L6.72444 27.9228C6.44029 28.4568 6.64776 29.1208 7.1845 29.4035H7.17998Z",
    fill: "url(#paint5_linear_616_12728)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4238 66.2669L78.4121 40.615C78.2497 40.1573 77.8573 39.8208 77.3792 39.7355C76.8695 39.6413 76.3598 39.5561 75.8547 39.4753L75.3676 38.0529C75.0518 37.1286 74.258 36.4466 73.2928 36.2716C72.1788 36.0697 71.0602 35.9037 69.9326 35.7691L68.8997 32.6506C68.7374 32.1571 68.2998 31.8026 67.7812 31.7353C67.0189 31.6411 50.2043 29.6444 43.75 37.4158C37.2957 29.6444 20.4811 31.6366 19.7188 31.7353C19.2001 31.7981 18.7672 32.1571 18.6003 32.6506L17.5674 35.7691C16.4443 35.9037 15.3212 36.0697 14.2072 36.2716C13.242 36.4466 12.4481 37.1286 12.1324 38.0529L11.6453 39.4753C11.1356 39.5561 10.626 39.6413 10.1208 39.7355C9.64271 39.8208 9.24579 40.1573 9.08793 40.615L0.0762469 66.2669C-0.0725948 66.6886 -0.000429146 67.1553 0.265682 67.5142C0.531792 67.8732 0.955766 68.0751 1.41131 68.0571C1.63683 68.0482 22.7633 67.1508 40.1552 68.461C40.7145 69.3718 41.8782 70 42.9562 70H44.4401C45.5135 70 46.6727 69.3718 47.2365 68.4655C64.651 67.1463 85.8632 68.0437 86.0887 68.0571C86.5442 68.0751 86.9682 67.8732 87.2343 67.5142C87.5004 67.1553 87.5726 66.6886 87.4238 66.2669ZM22.7994 61.3043C14.0674 61.3043 6.53507 62.8388 6.53507 62.8388L14.6988 38.9144C15.3528 38.7978 15.9933 38.6946 16.6292 38.6048L10.1388 58.2083C9.97647 58.7019 10.1118 59.2448 10.4907 59.5993C10.865 59.9582 11.4198 60.0704 11.9069 59.8864C25.5146 54.7489 35.902 60.905 40.3717 64.4362C35.3021 62.0222 28.7711 61.3043 22.7994 61.3043ZM42.3969 62.619C40.7867 61.3222 38.3917 59.6486 35.3247 58.2173C30.3588 55.8975 22.7092 53.856 13.5577 56.4943L20.9005 34.3108C24.4727 34.0057 38.3782 33.2878 42.3969 40.1573V62.619ZM45.1076 40.1663C49.1263 33.2923 63.0318 34.0102 66.604 34.3198L73.9468 56.5033C64.7953 53.8649 57.1457 55.9065 52.1799 58.2262C49.1128 59.6576 46.7133 61.3312 45.1076 62.6279V40.1663ZM64.7051 61.2998C58.7334 61.2998 52.2024 62.0177 47.1328 64.4317C51.6025 60.896 61.9899 54.7444 75.5976 59.8819C76.0847 60.0659 76.635 59.9537 77.0139 59.5948C77.3927 59.2358 77.528 58.6929 77.3657 58.2038L70.8753 38.6003C71.5112 38.6901 72.1562 38.7933 72.8057 38.9099L80.9694 62.8343C80.9694 62.8343 73.4371 61.2998 64.7051 61.2998Z",
    fill: "url(#paint6_linear_616_12728)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4331 11.2129H41.044V24.6648C41.044 25.4096 41.6483 26.0108 42.3971 26.0108H45.1033C45.852 26.0108 46.4564 25.4096 46.4564 24.6648V11.2129H52.0673C52.7032 11.2129 53.2174 10.7014 53.2174 10.0687V6.9772C53.2174 6.34454 52.7032 5.83303 52.0673 5.83303H46.4564V1.34608C46.4564 0.601251 45.852 0 45.1033 0H42.3971C41.6483 0 41.044 0.601251 41.044 1.34608V5.82855H35.4331C34.7971 5.82855 34.2829 6.34006 34.2829 6.97272V10.0642C34.2829 10.6969 34.7971 11.2084 35.4331 11.2084V11.2129Z",
    fill: "url(#paint7_linear_616_12728)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_616_12728",
    x1: 0,
    y1: 0,
    x2: 91.5012,
    y2: 5.69332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenBible);
export default __webpack_public_path__ + "static/media/icon-open-bible.b91ded5b71aebe643b6e307c3ee706ca.svg";
export { ForwardRef as ReactComponent };